import { useMutation, gql } from "@apollo/client";

const EMAIL_CONFIRMATION_MUTATION = gql`
  mutation ConfirmEmail($email: String!, $code: String!) {
    confirmEmail(email: $email, code: $code)
  }
`;

export const useConfirmEmailMutation = () => {
  const [confirmEmail, { loading, error, data }] = useMutation(
    EMAIL_CONFIRMATION_MUTATION,
    {
      // Optional: You can add other options like refetchQueries or awaitRefetchQueries if needed
    }
  );

  const handleConfirmEmail = async (email: string, code: string) => {
    try {
      const response = await confirmEmail({
        variables: { email, code },
      });
      // Returns user ID (string) if successful, or false if failed
      return response.data.confirmEmail;
    } catch (err) {
      console.error("Error confirming email:", err);
      return { error: "Failed to confirm email" }; // Handle error as needed
    }
  };

  return {
    handleConfirmEmail,
    loading,
    error,
    data,
  };
};
